import { useGlobalConfig } from "@/composables/useGlobalConfig";

export enum Keys {
  assistantId = "assistantId",
  chatId = "chatId",
  chatHistory = "chatHistory",
  token = "token",
  userId = "userId",
}

export const usePreferences = () => {
  const getPreferences = (key: string): string | null => {
    return localStorage.getItem(getPreferencesKey(key));
  };

  const setPreferences = (key: string, value: string): void => {
    localStorage.setItem(getPreferencesKey(key), value);
  };

  const removePreferences = (key: string): void => {
    localStorage.removeItem(getPreferencesKey(key));
  };

  const clearPreferences = (): void => {
    const keys = Object.keys(Keys);

    for (const key of keys) {
      removePreferences(key);
    }
  };

  const getPreferencesKey = (key: string): string => {
    const { assistantId } = useGlobalConfig();
    return assistantId.value + "." + key;
  };

  return {
    getPreferences,
    setPreferences,
    removePreferences,
    clearPreferences,
  };
};
